import Cookies from "js-cookie";

// Read by the role-token saga to send the user back here after logging in.
export const RETURN_URL_COOKIE = "mhet_mst_returnurl";

// Long enough to finish logging in, short enough that an abandoned login does
// not send a later one (possibly another verifier on the same phone) back to an
// earlier candidate.
const RETURN_URL_LIFETIME_DAYS = 15 / (24 * 60); // 15 minutes

export const saveReturnUrl = (url) => {
  Cookies.set(RETURN_URL_COOKIE, url, { expires: RETURN_URL_LIFETIME_DAYS });
};

export const clearReturnUrl = () => {
  Cookies.remove(RETURN_URL_COOKIE);
};

// Keeps the current candidate-verification link (a scanned QR's ?data= or the
// roll-number search) when a verifier's login has expired, so they land back on
// it after logging in again instead of having to scan the QR a second time.
export const rememberVerificationUrl = () => {
  const { pathname, search } = window.location;
  if (pathname.endsWith("/candidate-verification")) {
    saveReturnUrl(`${pathname}${search}`);
  }
};
